"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LineHeight = exports.FontSize = exports.FontFamily = void 0;
let FontFamily;
exports.FontFamily = FontFamily;

(function (FontFamily) {
  FontFamily["inter"] = "Inter, Arial, \"Helvetica Neue\", sans-serif";
  FontFamily["mono"] = "MonoLisa, \"Source Code Pro\", Courier, FreeMono, \"SF Mono\", Monaco, Menlo, Consolas, \"Ubuntu Mono\", \"Liberation Mono\", \"DejaVu Sans Mono\", \"Courier New\", monospace";
})(FontFamily || (exports.FontFamily = FontFamily = {}));

let FontSize;
exports.FontSize = FontSize;

(function (FontSize) {
  FontSize[FontSize["small"] = 12] = "small";
  FontSize[FontSize["medium"] = 14] = "medium";
  FontSize[FontSize["large"] = 16] = "large";
})(FontSize || (exports.FontSize = FontSize = {}));

let LineHeight;
exports.LineHeight = LineHeight;

(function (LineHeight) {
  LineHeight[LineHeight["small"] = 16] = "small";
  LineHeight[LineHeight["medium"] = 20] = "medium";
  LineHeight[LineHeight["large"] = 24] = "large";
})(LineHeight || (exports.LineHeight = LineHeight = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJGb250RmFtaWx5IiwiRm9udFNpemUiLCJMaW5lSGVpZ2h0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RoZW1lL3R5cG9ncmFwaHkvdHlwb2dyYXBoeS50eXBlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZW51bSBGb250RmFtaWx5IHtcbiAgaW50ZXIgPSAnSW50ZXIsIEFyaWFsLCBcIkhlbHZldGljYSBOZXVlXCIsIHNhbnMtc2VyaWYnLFxuICBtb25vID0gJ01vbm9MaXNhLCBcIlNvdXJjZSBDb2RlIFByb1wiLCBDb3VyaWVyLCBGcmVlTW9ubywgXCJTRiBNb25vXCIsIE1vbmFjbywgTWVubG8sIENvbnNvbGFzLCBcIlVidW50dSBNb25vXCIsIFwiTGliZXJhdGlvbiBNb25vXCIsIFwiRGVqYVZ1IFNhbnMgTW9ub1wiLCBcIkNvdXJpZXIgTmV3XCIsIG1vbm9zcGFjZScsXG59XG5cbmV4cG9ydCBlbnVtIEZvbnRTaXplIHtcbiAgc21hbGwgPSAxMixcbiAgbWVkaXVtID0gMTQsXG4gIGxhcmdlID0gMTYsXG59XG5cbmV4cG9ydCBlbnVtIExpbmVIZWlnaHQge1xuICBzbWFsbCA9IDE2LFxuICBtZWRpdW0gPSAyMCxcbiAgbGFyZ2UgPSAyNCxcbn1cbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0lBQVlBLFU7OztXQUFBQSxVO0VBQUFBLFU7RUFBQUEsVTtHQUFBQSxVLDBCQUFBQSxVOztJQUtBQyxROzs7V0FBQUEsUTtFQUFBQSxRLENBQUFBLFE7RUFBQUEsUSxDQUFBQSxRO0VBQUFBLFEsQ0FBQUEsUTtHQUFBQSxRLHdCQUFBQSxROztJQU1BQyxVOzs7V0FBQUEsVTtFQUFBQSxVLENBQUFBLFU7RUFBQUEsVSxDQUFBQSxVO0VBQUFBLFUsQ0FBQUEsVTtHQUFBQSxVLDBCQUFBQSxVIn0=